/**
 * Copy URL ボタン
 *
 * @description クリップボードへコピーし、押した直後だけラベルを差し替えて結果を伝える
 */

const COPIED_LABEL = 'Copied!';
const REVERT_DELAY = 1800;

/**
 * ボタンのラベルを一時的に差し替える
 *
 * @param el 差し替える対象のテキスト要素
 * @param text 表示するテキスト
 */
const flashLabel = (el: HTMLElement, text: string): void => {
    const original = el.dataset.shareLabel ?? el.textContent ?? '';

    // 連打されても元のラベルを失わないよう、初回だけ退避する
    if (!el.dataset.shareLabel) {
        el.dataset.shareLabel = original;
    }

    el.textContent = text;

    window.setTimeout(() => {
        el.textContent = el.dataset.shareLabel ?? original;
    }, REVERT_DELAY);
};

/**
 * URLをクリップボードへ書き込む
 *
 * @param url コピーするURL
 */
const copyUrl = async (url: string): Promise<boolean> => {
    try {
        await navigator.clipboard.writeText(url);
        return true;
    } catch {
        return false;
    }
};

/**
 * Copy URL ボタンを初期化する
 */
const initShareCopy = (): void => {
    const buttons = document.querySelectorAll<HTMLElement>('[data-share-copy]');

    buttons.forEach((button) => {
        button.addEventListener('click', async () => {
            const url = button.dataset.shareCopy ?? location.href;
            const label = button.querySelector<HTMLElement>('.Share__listItemLinkTxt');
            const ok = await copyUrl(url);

            if (label) {
                flashLabel(label, ok ? COPIED_LABEL : 'Failed');
            }
        });
    });
};

export { initShareCopy };

document.addEventListener('DOMContentLoaded', initShareCopy);
